let InsuranceProtectionType = /*#__PURE__*/function (InsuranceProtectionType) {
  InsuranceProtectionType["NONE"] = "none";
  InsuranceProtectionType["BASIC"] = "basic";
  InsuranceProtectionType["FULL"] = "full";
  InsuranceProtectionType["MAX"] = "max";
  return InsuranceProtectionType;
}({});
let InsuranceType = /*#__PURE__*/function (InsuranceType) {
  InsuranceType["PACKLINK_INSURANCE"] = "PACKLINK_INSURANCE";
  InsuranceType["PROOF_OF_DELIVERY"] = "PROOF_OF_DELIVERY";
  InsuranceType["NO_INSURANCE"] = "NO_INSURANCE";
  InsuranceType["STANDARD"] = "STANDARD";
  InsuranceType["ENHANCED"] = "ENHANCED";
  return InsuranceType;
}({});

export { InsuranceProtectionType, InsuranceType };
//# sourceMappingURL=Products.js.map
